import { render, staticRenderFns } from "./AffiliateWeeklyCommissionsView.vue?vue&type=template&id=5865c7b5&"
import script from "./AffiliateWeeklyCommissionsView.vue?vue&type=script&lang=js&"
export * from "./AffiliateWeeklyCommissionsView.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateWeeklyCommissionsView.vue?vue&type=style&index=0&id=5865c7b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports